module.exports = __webpack_public_path__ + "img/logo.b9206bc2.png";